import { resolveAdminLocale } from '@/apps/admin/i18n/locale'
import { resolvePortalLocale } from '@/apps/portal/i18n/locale'

export const resolveRouteLocale = (
  adminRoute: boolean,
  adminLocale: string | null | undefined,
  preferredLocale: string | null | undefined,
  legacyLocale: string | null | undefined
): string => {
  if (adminRoute) return resolveAdminLocale(adminLocale)
  return resolvePortalLocale(preferredLocale, legacyLocale)
}
